import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import FormStep from './components/FormStep';
import Footer from './components/Footer';
import { FormProvider } from './context/FormContext';
import ThankYou from './components/ThankYou';
import ScrollToTop from './components/ScrollToTop'; // 👈 Add this line
import './App.css';
import TermsAndConditions from './components/TermsAndConditions.jsx';
import NotFound from './components/NotFound.jsx';

function App() {
  return (
    <FormProvider>
      <Router>
        <ScrollToTop /> {/* 👈 Add this line here */}
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Navigate to="/step/1" replace />} />
              <Route path="/step/:stepId" element={<FormStep />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </FormProvider>
  );
}

export default App;
